exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grilla {\n  padding-right: 0 !important;\n}\n", ""]);

// exports
